export class MiniQuestionGivenAnswers {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get miniQuestion() {
        return this.parent;
    }
    get app() {
        return this.miniQuestion.app;
    }
}
